import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ConfigResolverService } from './config-resolver.service';

@Pipe({
  name: 'configPartnerLogo',
  standalone: true,
})
export class ConfigPartnerLogoPipe implements PipeTransform {
  constructor(readonly configResolver: ConfigResolverService) {}
  transform(portalId: number | null): Observable<string | null> {
    return this.configResolver
      .resolveOtherProperty<string>(portalId, 'logoFileName')
      .pipe(
        map((fileName) => (fileName ? 'assets/ui/images/' + fileName : null))
      );
  }
}

@Pipe({
  name: 'configPartnerShowProductIcon',
  standalone: true,
})
export class ConfigPartnerShowProductIconPipe implements PipeTransform {
  constructor(readonly configResolver: ConfigResolverService) {}
  transform(portalId: number | null): Observable<boolean | null> {
    return this.configResolver.resolveOtherProperty<boolean>(
      portalId,
      'showProductIcon'
    );
  }
}
